import request from '@/utils/request'
import qs from 'qs'
export function getCancelGuestList(query) {
  return request({
    url: '/report-service/v1/report/guest-cancel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getCancelGuestExcel(query) {
  return request({
    url: '/report-service/v1/report/guest-cancel-excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
